import React from "react"
import { useHits } from 'react-instantsearch';
const root = document.querySelector(".accordion-product-properties")

   if( root )
    {
        const productData           = JSON.parse(root.getAttribute("data-productData"));
        var hideProductInfo       = productData.hideProductInfo;
        var hidePhotometricInfo   = productData.hidePhotometricInfo;
        var hidePackagingInfo     = productData.hidePackagingInfo;
        var packagingInfoNoData     = true;
    } 
const lumenOutput = (hit) => {
    var lumenComponent = "";
    if( hit.ostendoLumenOutput && hit.ostendoLumenOutput.length > 0)
    {
        var lumenOutputArr = hit.ostendoLumenOutput;
 
        if(lumenOutputArr.length > 1)
        {
            var minLumen = Math.min(...lumenOutputArr);
            var maxLumen = Math.max(...lumenOutputArr);
             lumenComponent =  <li className="accordion__item">  <span>System Lumen Range</span> <span>{minLumen}lm - {maxLumen}lm</span> </li>
        }
        else
        {
             lumenComponent =  <li className="accordion__item">  <span>System Lumen Output</span> <span>{lumenOutputArr}lm</span> </li>
        }
    }
   
    return lumenComponent;
}
const systemPower = (hit) => {
   
    var systemPowerComponent = "";
    if( hit.ostendoSystemPower && hit.ostendoSystemPower.length > 0)
    {
        var systemPowerArr = hit.ostendoSystemPower;
        var systemPowerArr = systemPowerArr.sort().join('W, ');
        systemPowerComponent =  <li className="accordion__item"><span>System Power</span> <span>{systemPowerArr}W</span> </li>
    }
    return systemPowerComponent;
}

const systemEfficacy =  (hit) =>  {

    const productData = JSON.parse(root.getAttribute("data-productData"));
    var systemEfficacyComponent = "";

    if( productData.systemEfficacy && productData.systemEfficacy != "")
    {
        const systemEfficacy = productData.systemEfficacy;
        systemEfficacyComponent =  <li className="accordion__item"><span>System Efficacy (max.)</span> <span>{systemEfficacy}lm/W</span> </li>
    }
    
    return systemEfficacyComponent;
}
const ostendoInputVoltage = (hit) => {
    
    var ostendoInputVoltageComponent = "";
    if( hit.ostendoInputVoltage && hit.ostendoInputVoltage.length > 0 )
    {
        var ostendoInputVoltageArr = hit.ostendoInputVoltage;
        var ostendoInputVoltageArr = ostendoInputVoltageArr.join('V, ');
        ostendoInputVoltageComponent =  <li className="accordion__item"><span>Input Voltage</span> <span>{ostendoInputVoltageArr}</span> </li>
    }
    return ostendoInputVoltageComponent;
}
const ostendoTrimColour = (hit) => {
    var ostendoTrimColourComponent = "";
    if( hit.ostendoTrimColour && hit.ostendoTrimColour.length > 0)
    {
        var ostendoTrimColourArr = hit.ostendoTrimColour;
        var ostendoTrimColourArr = ostendoTrimColourArr.join(', ');
        ostendoTrimColourComponent =  <li className="accordion__item"><span>Body/Trim Colour</span> <span>{ostendoTrimColourArr}</span> </li>
    }

    return ostendoTrimColourComponent;
}
const ostendoInstallationMethod = (hit) => {
    var ostendoInstallationMethodComponent = "";

    if( hit.ostendoInstallationMethod && hit.ostendoInstallationMethod.length > 0)
    {
        var ostendoInstallationMethodArr = hit.ostendoInstallationMethod;
        var ostendoInstallationMethodArr = ostendoInstallationMethodArr.join(', ');
        ostendoInstallationMethodComponent =  <li className="accordion__item"><span>Installation Method</span> <span>{ostendoInstallationMethodArr}</span> </li>
    }
   
    return ostendoInstallationMethodComponent;
}
const ostendoDimmingOption = (hit) => {
    var ostendoDimmingOptionComponent = "";
    if( hit.ostendoDimmingOption && hit.ostendoDimmingOption.length > 0)
    {
        var ostendoDimmingOptionArr = hit.ostendoDimmingOption;
        var ostendoDimmingOptionArr = ostendoDimmingOptionArr.join(', ');
        ostendoDimmingOptionComponent =  <li className="accordion__item"><span>Dimming Type</span> <span>{ostendoDimmingOptionArr}</span> </li>
    }

    return ostendoDimmingOptionComponent;
}
const ostendoIpRating = (hit) => {
    var ostendoIpRatingComponent = "";
    if( hit.ostendoIpRating && hit.ostendoIpRating.length > 0)
    {
        var ostendoIpRatingArr = hit.ostendoIpRating;
        var ostendoIpRatingArr = ostendoIpRatingArr.join(', ');
        ostendoIpRatingComponent =  <li className="accordion__item"><span>IP Rating</span> <span>{ostendoIpRatingArr}</span> </li>
    }
 
    return ostendoIpRatingComponent;
}
const ostendoMaxTiltAngle = (hit) => {
    var ostendoMaxTiltAngleComponent = "";
    if( hit.ostendoMaxTiltAngle && hit.ostendoMaxTiltAngle.length > 0)
    {
        var ostendoMaxTiltAngleArr = hit.ostendoMaxTiltAngle;
        var ostendoMaxTiltAngleArr = ostendoMaxTiltAngleArr.join(', ');
        ostendoMaxTiltAngleComponent =  <li className="accordion__item"><span>Maximum Tilt Angle</span> <span>{ostendoMaxTiltAngleArr}</span> </li>
    }
    return ostendoMaxTiltAngleComponent;
}
const ostendoMaxRotationAngle = (hit) => {
    var ostendoMaxRotationAngleComponent = "";
    if(hit.ostendoMaxRotationAngle  && hit.ostendoMaxRotationAngle.length > 0)
    {
        var ostendoMaxRotationAngleArr = hit.ostendoMaxRotationAngle;
        var ostendoMaxRotationAngleArr = ostendoMaxRotationAngleArr.join(', ');
        ostendoMaxRotationAngleComponent =  <li className="accordion__item"><span>Maximum Rotaion Angle</span> <span>{ostendoMaxRotationAngleArr}</span> </li>
    }
    return ostendoMaxRotationAngleComponent;
}
const ostendoAccessories = (hit) => {
    var ostendoAccessoriesComponent = "";
    if(hit.ostendoAccessories && hit.ostendoAccessories.length > 0 )
    {
        var ostendoAccessoriesArr = hit.ostendoAccessories;

        var ostendoAccessoriesVal = "";
        ostendoAccessoriesArr.map(function( item ){
            ostendoAccessoriesVal =  <span> {item}  <br /></span>;
        })
      //  var ostendoAccessoriesArr = ostendoAccessoriesArr.join(', ');
        var scrollableArray = "";
        var scrollableArrayContent = "";
        if( hit.ostendoAccessories.length > 5)
        {
            var scrollableArray = "accordion__item--scrollable";
            var scrollableArrayContent = "accordion__item-content";
        }
        ostendoAccessoriesComponent =  <li className={scrollableArray+" accordion__item"}><span>Accessories</span> <span className={scrollableArrayContent} >{ostendoAccessoriesArr.map(function( item ){
            return  <span key={item}> {item}  <br /></span>;
        })}</span> </li>
      
    }
   
    return ostendoAccessoriesComponent;
}
const ostendoCalculatedVeetIpartApproved = (hit) => {

    var ostendoCalculatedVeetIpartApprovedComponent = "";
    if(  hit.ostendoCalculatedVeetIpartApproved  != null  && hit.ostendoCalculatedVeetIpartApproved.length > 0)
    {
        var ostendoCalculatedVeetIpartApprovedArr = hit.ostendoCalculatedVeetIpartApproved;
        var ostendoCalculatedVeetIpartApprovedArr = ostendoCalculatedVeetIpartApprovedArr.join(', ');
        ostendoCalculatedVeetIpartApprovedComponent =  <li className="accordion__item"><span>VEU/IPART Approved</span> <span>{ostendoCalculatedVeetIpartApprovedArr}</span> </li>
    }
    return ostendoCalculatedVeetIpartApprovedComponent;
}

const customSpecs = (hit) => {
    const productData = JSON.parse(root.getAttribute("data-productData"));
    const customSpecs = productData.customSpecs;
    var customSpecsComponent = [];
    if( customSpecs.length > 0 )
    {
        customSpecs.map(function(item, index ){
            if(item.type == 'product' && item.displayOnProduct)
            {
                customSpecsComponent[index] =  <li className="accordion__item"><span>{item.heading}</span> <span>{item.data}</span> </li>
            }
        });
    }
   
    return customSpecsComponent;
}

const ostendoColourRenderingIndex = (hit) => {

    var ostendoColourRenderingIndexComponent = "";

    if(  hit.ostendoColourRenderingIndex && hit.ostendoColourRenderingIndex.length > 0 )
    {
        var ostendoColourRenderingIndexArr = hit.ostendoColourRenderingIndex;
        var ostendoColourRenderingIndexArr = ostendoColourRenderingIndexArr.join(', ');
        ostendoColourRenderingIndexComponent =  <li className="accordion__item"><span>Colour Rendering Index (CRI)</span> <span>{ostendoColourRenderingIndexArr}</span> </li>
    }
    return ostendoColourRenderingIndexComponent;
}

const ostendoColourTemperature = (hit) => {

    var ostendoColourTemperatureComponent = "";

    if(  hit.ostendoColourTemperature  != null && hit.ostendoColourTemperature.length > 0 )
    {
        var ostendoColourTemperatureArr = hit.ostendoColourTemperature;
        var ostendoColourTemperatureArr = ostendoColourTemperatureArr.sort().join(', ');
        ostendoColourTemperatureComponent =  <li className="accordion__item"><span>Colour Temperature (CCT)</span> <span>{ostendoColourTemperatureArr}</span> </li>
    }
    return ostendoColourTemperatureComponent;
}
const ostendoBeamAngle = (hit) => {

    var ostendoBeamAngleComponent = "";

    if( hit.ostendoBeamAngle && hit.ostendoBeamAngle.length > 0 )
    {
        var ostendoBeamAngleArr = hit.ostendoBeamAngle;
        var ostendoBeamAngleArr = ostendoBeamAngleArr.sort().join(', ');
        ostendoBeamAngleComponent =  <li className="accordion__item"><span>Beam Angle</span> <span>{ostendoBeamAngleArr}</span> </li>
    }
    return ostendoBeamAngleComponent;
}
const ostendoLightOutputRatio = (hit) => {

    var ostendoLightOutputRatioComponent = "";

    if(  hit.ostendoLightOutputRatio  != null && hit.ostendoLightOutputRatio.length > 0 )
    {
        var ostendoLightOutputRatioArr = hit.ostendoLightOutputRatio;
        var ostendoLightOutputRatioArr = ostendoLightOutputRatioArr.join(', ');
        ostendoLightOutputRatioComponent =  <li className="accordion__item"><span>Light Output Ratio (LOR)</span> <span>{ostendoLightOutputRatioArr}</span> </li>
    }
    return ostendoLightOutputRatioComponent;
}
const ostendoUnifiedGlareRating = (hit) => {

    var ostendoUnifiedGlareRatingComponent = "";

    if( hit.ostendoUnifiedGlareRating &&  hit.ostendoUnifiedGlareRating.length  > 0 )
    {
        var ostendoUnifiedGlareRatingArr = hit.ostendoUnifiedGlareRating;
        var ostendoUnifiedGlareRatingArr = ostendoUnifiedGlareRatingArr.join(', ');
        ostendoUnifiedGlareRatingComponent =  <li className="accordion__item"><span>Unified Glare Rating (UGR)</span> <span>{ostendoUnifiedGlareRatingArr}</span> </li>
    }
    return ostendoUnifiedGlareRatingComponent;
}


const customSpecsPhotometric = (hit) => {
    const productData = JSON.parse(root.getAttribute("data-productData"));
    const customSpecs = productData.customSpecs;
    var customSpecsComponent = [];
    if( customSpecs.length > 0 )
    {
        customSpecs.map(function(item, index ){
            if(item.type == 'photometric' && item.displayOnProduct)
            {
                customSpecsComponent[index] =  <li className="accordion__item"><span>{item.heading}</span> <span>{item.data}</span> </li>
            }
        });
    }
  
    return customSpecsComponent;
}

const ostendoLumenMaintenance = (hit) => {

    var ostendoLumenMaintenanceComponent = "";

    if(  hit.ostendoLumenMaintenance  != null && hit.ostendoLumenMaintenance.length > 0)
    {
        var ostendoLumenMaintenanceArr = hit.ostendoLumenMaintenance;
        var ostendoLumenMaintenanceArr = ostendoLumenMaintenanceArr.join(', ');
        ostendoLumenMaintenanceComponent =  <li className="accordion__item"><span>Lumen Maintenance (L70)</span> <span>{ostendoLumenMaintenanceArr}</span> </li>
    }
    return ostendoLumenMaintenanceComponent;
}
const ostendoMacAdamStep = (hit) => {

    var ostendoMacAdamStepComponent = "";

    if(  hit.ostendoMacAdamStep && hit.ostendoMacAdamStep.length  > 0 )
    {
        var ostendoMacAdamStepArr = hit.ostendoMacAdamStep;
        var ostendoMacAdamStepArr = ostendoMacAdamStepArr.join(', ');
        ostendoMacAdamStepComponent =  <li className="accordion__item"><span>MacAdam Step</span> <span>{ostendoMacAdamStepArr}</span> </li>
    }
    return ostendoMacAdamStepComponent;
}
const customSpecsPackaging = (hit) => {
    const productData = JSON.parse(root.getAttribute("data-productData"));
    const customSpecs = productData.customSpecs;
    var customSpecsComponent = [];
    if( customSpecs.length > 0 )
    {
        customSpecs.map(function(item, index ){
            if(item.type == 'packaging' && item.displayOnProduct)
            {
                customSpecsComponent[index] =  <li className="accordion__item"><span>{item.heading}</span> <span>{item.data}</span> </li>
            }
        });
    }
  
    return customSpecsComponent;
}
const checkCustomSpecsPackaging = () => {
    const productData = JSON.parse(root.getAttribute("data-productData"));
    const customSpecs = productData.customSpecs;
    if( customSpecs.length > 0 )
    {
        customSpecs.map(function(item, index ){
            if(item.type == 'packaging' && item.displayOnProduct && packagingInfoNoData == true)
            {
                packagingInfoNoData = false;
            }
        });
    }
 
    return packagingInfoNoData;
}
const accordion = () => {
	const accordions = [...document.querySelectorAll(".js-accordion")]
	accordions.forEach((el) => {
		const trigger = el.querySelector(".js-accordion-trigger")
		trigger.addEventListener("click", () => {
			el.classList.toggle("is-collapsed")
		})
	})
}
function HitsList(){
    const { items  } = useHits();
  
        return (<div className="product-list">
        {items.slice(0, 1).map(hit => (
            <div className={"product-list-inner"} key={hit.id+"htls"}>
        {hideProductInfo == false && 
            <div className="accordion js-accordion">
                 <h4 className="accordion__heading js-accordion-trigger"> Product info
                    <svg><use xlinkHref="#chevron-up"/> </svg>
                </h4>
                <ul className="accordion__list">
                    {lumenOutput(hit)}
                    {systemPower(hit)}
                    {systemEfficacy(hit)}     
                    {ostendoInputVoltage(hit)}
                    {ostendoTrimColour(hit)}
                    {ostendoInstallationMethod(hit)}   
                    {ostendoIpRating(hit)}
                    {ostendoDimmingOption(hit)}
                    {ostendoMaxTiltAngle(hit)} 
                    {ostendoMaxRotationAngle(hit)}     
                    {ostendoAccessories(hit)}  
                    {ostendoCalculatedVeetIpartApproved(hit)}
                    {customSpecs(hit)}
                </ul>
            </div>
            }
             {hidePhotometricInfo == false && 
            <div className="accordion js-accordion">
                <h4 className="accordion__heading js-accordion-trigger"> Photometric info
                    <svg> <use xlinkHref="#chevron-up"/> </svg>
                </h4>
                <ul className="accordion__list">
                {ostendoColourRenderingIndex(hit)}
                {ostendoColourTemperature(hit)}
                {ostendoBeamAngle(hit)}
                {ostendoLightOutputRatio(hit)}
                {ostendoUnifiedGlareRating(hit)}
                {customSpecsPhotometric(hit)}
                {ostendoLumenMaintenance(hit)}
                {ostendoMacAdamStep(hit)}
                </ul>
            </div>
             }
              {hidePackagingInfo == false && checkCustomSpecsPackaging() == false && 
            <div className="accordion js-accordion">
                <h4 className="accordion__heading js-accordion-trigger"> Packaging info
                    <svg> <use xlinkHref="#chevron-up"/> </svg>
                </h4>
                <ul className="accordion__list">
                {customSpecsPackaging(hit)}
                </ul>
            </div>
             }
            </div>
            ))}
    </div>)
}
    
function ProductsAccordion({ query, isActive }){
if( !root )
{
    return null;
} 
    return (   <div className="product-info-custom bg--grey-lighter">
                <HitsList query={query} />
                {accordion()}
            </div> )
}
export default ProductsAccordion